import React from 'react';
import { graphql } from 'gatsby';

import Post from './post';

export default Post;
export { Head } from './post';

export const query = graphql`
    query News($id: String, $language: String) {
        categoryName: getTranslation(key: "news", language: $language)
        post: datoCmsNews(id: { eq: $id }, locale: { eq: $language }) {
            title
            featuredImage {
                ...PostFeaturedImage
            }
            meta {
                firstPublishedAt(locale: $language, formatString: "LL")
            }
            authors {
                name
            }
            content {
                value
                links {
                    __typename
                    ... on DatoCmsFile {
                        id: originalId
                        file {
                            alt
                            filename
                            title
                            url
                        }
                    }
                    ... on DatoCmsNews {
                        id: originalId
                        slug
                        title
                    }
                    ... on DatoCmsStudyCase {
                        id: originalId
                        slug
                        title
                    }
                    ... on DatoCmsArticle {
                        id: originalId
                        slug
                        title
                    }
                    ... on DatoCmsPage {
                        id: originalId
                        slug
                        title
                    }
                }
                blocks {
                    __typename
                    ... on DatoCmsImage {
                        id: originalId
                        link {
                            url
                        }
                        image {
                            alt
                            url
                            gatsbyImageData(
                                width: 960
                                placeholder: BLURRED
                                layout: CONSTRAINED
                            )
                        }
                        externalSource
                        externalLink
                    }
                    ... on DatoCmsSnippet {
                        id: originalId
                        snippet
                        contentScripts {
                            src
                            content
                        }
                    }
                    ... on DatoCmsVideoEmbed {
                        id: originalId
                        video {
                            provider
                            height
                            providerUid
                            title
                            width
                        }
                    }
                }
            }
            relatedCaseOfStudy {
                ...CaseStudyItem
            }
            relatedPosts {
                ...PostItem
                meta {
                    firstPublishedAt(locale: $language, formatString: "ll")
                }
            }
            excerpt
            seo {
                title
                description
                image {
                    id
                }
            }
            seoImage: featuredImage {
                ...PostSeoImage
            }
            serviceTeamMember {
                ...CardPerson
            }
            buTeamMember {
                ...CardPerson
            }
            servicesSectors {
                __typename
                ... on DatoCmsSector {
                    ...DatoCmsSector
                }
                ... on DatoCmsCategory {
                    ...DatoCmsCategory
                }
            }
            services {
                ...DatoCmsService
            }
        }
    }
`;
